<div class="workspace-page br-compact-page">
  <header class="workspace-page__heading">
    <h1 class="workspace-page__title">Scheduled Jobs</h1>
  </header>

  <!-- Times on this page are the company's local wall clock, so say which. -->
  <div class="tz-banner br-alert" [class.tz-banner--warn]="!timeZoneConfigured">
    <br-icon>{{ timeZoneConfigured ? 'schedule' : 'warning' }}</br-icon>
    <span *ngIf="timeZoneConfigured">
      Times are this company's local time — <strong>{{ timeZoneId }}</strong>.
    </span>
    <span *ngIf="!timeZoneConfigured">
      No company time zone set, so these times are read as <strong>UTC</strong>.
      Set the zone on the Staff page for them to mean local time.
    </span>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <div *ngIf="loadError" class="load-error br-alert br-alert--danger">{{ loadError }}</div>

  <mat-card class="job-card" *ngFor="let row of rows">
    <mat-card-content>
      <div class="job-head">
        <div class="job-title">
          <mat-slide-toggle [(ngModel)]="row.isEnabled" [disabled]="!canManage"
                            matTooltip="Enable or pause this job"></mat-slide-toggle>
          <div>
            <div class="job-name">{{ row.displayName }}</div>
            <div class="job-desc">{{ row.description }}</div>
          </div>
        </div>

        <div class="job-actions">
          <button type="button" class="br-btn br-btn--outline-secondary" *ngIf="canManage"
                  [disabled]="runningId === row.id"
                  (click)="runNow(row)"
                  matTooltip="Run once now, without changing the schedule">
            <br-icon>play_arrow</br-icon>
            {{ runningId === row.id ? 'Running…' : 'Run now' }}
          </button>
          <button type="button" class="br-btn br-btn--primary" *ngIf="canManage"
                  [disabled]="savingId === row.id"
                  (click)="save(row)">
            {{ savingId === row.id ? 'Saving…' : 'Save' }}
          </button>
        </div>
      </div>

      <div class="job-controls" [class.job-controls--off]="!row.isEnabled">
        <mat-form-field appearance="outline" class="f-freq">
          <mat-label>Frequency</mat-label>
          <mat-select [(ngModel)]="row.frequency" [disabled]="!canManage"
                      (ngModelChange)="onFrequencyChange(row)">
            <mat-option value="daily">Daily</mat-option>
            <mat-option value="weekly">Weekly</mat-option>
            <mat-option value="monthly">Monthly</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="f-day" *ngIf="row.frequency === 'weekly'">
          <mat-label>Day</mat-label>
          <mat-select [(ngModel)]="row.dayOfWeek" [disabled]="!canManage">
            <mat-option *ngFor="let d of dayLabels; let i = index" [value]="i">{{ d }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="f-day" *ngIf="row.frequency === 'monthly'">
          <mat-label>Day of month</mat-label>
          <mat-select [(ngModel)]="row.dayOfMonth" [disabled]="!canManage">
            <mat-option *ngFor="let d of daysOfMonth" [value]="d">{{ d }}</mat-option>
          </mat-select>
          <mat-hint>1–28, so every month fires</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="f-time">
          <mat-label>Time</mat-label>
          <input matInput type="time" [(ngModel)]="row.runAt" [disabled]="!canManage">
        </mat-form-field>

        <div class="job-meta">
          <span *ngIf="row.nextRunLocalDate">
            Next run <strong>{{ row.nextRunLocalDate }}</strong> at {{ row.runAt }}
          </span>
          <span *ngIf="!row.nextRunLocalDate" class="meta-muted">Paused — will not run</span>

          <span class="job-last">
            <span [class]="statusClass(row.lastRunStatus)">
              {{ row.lastRunStatus ?? 'Never run' }}
            </span>
            <ng-container *ngIf="row.lastRunAt">
              {{ row.lastRunAt | date:'M/d h:mm a' }}
            </ng-container>
            <span class="job-note" *ngIf="row.lastRunNote">— {{ row.lastRunNote }}</span>
          </span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div *ngIf="!loading && rows.length === 0 && !loadError" class="empty-state">
    <br-icon>schedule</br-icon>
    <p>No jobs are scheduled for this company.</p>
  </div>

</div>
